import React from 'react';
import ListClient from '../../usecase/ListClients';
import { Row, Col, Button } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import TextField from '../../components/TextField';

import './Home.css';

export default class Home extends React.Component {
    constructor() {
        super();

        this.state = {
            fieldStatus: 'success',
            renderForm: false,
            clients: [],
            clientFilter: ''
        };
    }

    componentDidMount() {
        ListClient.execute((clients) => {
            this.setState({clients});
        });
    }
    
    createClient = () => this.setState({renderForm: true});
    
    updateField = (event) => {
        const client = {};
        client[event.target.id] = event.target.value;
        this.setState({...client});
    };

    saveClient = () => {
        console.log(this.state)
    };

    renderClientList() {
        return (
            <Row id="ClientPageRow">
                <Col xsHidden sm={8}>
                    <TextField
                        id="clientFilter"
                        type="text"
                        placeholder="Digite sua pesquisa"
                        onChange={(event) => this.setState({ clientFilter: event.target.value })}
                        state={this.state.fieldStatus}
                    />
                </Col>
                <Col xs={12} sm={4}>
                    <Row>
                        <Col xs={12}>
                            <Button
                                id="createClient"
                                onClick={this.createClient}
                                bsStyle="primary"
                                block
                            >
                                Cadastrar Novo Cliente
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12}>
                {this.state.clients.filter(client => client && client.NAME.toLowerCase().indexOf(this.state.clientFilter.toLowerCase()) > -1)
                    .map(client => {
                        return (
                            <Row key={client.CLIENT_ID}>
                                <Col xs={12}>
                                    {client.NAME} {client.PHONE}
                                </Col>
                                <Col xs={12}>
                                    {client.EMAIL}
                                </Col>
                                <Col xs={12}>
                                    {client.ADRESS}
                                </Col>
                            </Row>
                            );
                        })}
                </Col>
            </Row>
        );
    }

    renderClientForm(){
        return (
            <Row id="ClientPageRow">
                <Col xs={12}>
                    <Row>
                        <Col xs={12} sm={8}>
                            <TextField
                                id="nome"
                                type="text"
                                label="Nome"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <TextField
                                id="numero"
                                type="text"
                                label="Número"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6}>
                            <TextField
                                id="cpf"
                                type="text"
                                label="CPF"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={6}>
                            <TextField
                                id="rg"
                                type="text"
                                label="RG"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TextField
                                id="endereco"
                                type="text"
                                label="Endereço"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6}>
                            <TextField
                                id="bairro"
                                type="text"
                                label="Bairro"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <TextField
                                id="cidade"
                                type="text"
                                label="Cidade"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={2}>
                            <TextField
                                id="uf"
                                type="text"
                                label="UF"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6}>
                            <TextField
                                id="telefone"
                                type="text"
                                label="Telefone"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={6}>
                            <TextField
                                id="celular"
                                type="text"
                                label="Celular"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={2}>
                            <TextField
                                id="sexo"
                                type="text"
                                label="Sexo"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={6}>
                            <TextField
                                id="dataNascimento"
                                type="text"
                                label="Data de nascimento"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <TextField
                                id="idade"
                                type="text"
                                label="Idade"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TextField
                                id="profissao"
                                type="text"
                                label="Profissão"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TextField
                                id="estadoCivil"
                                type="text"
                                label="Estado Civil"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={8}>
                            <TextField
                                id="conjuge"
                                type="text"
                                label="Cônjuge"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <TextField
                                id="contatoConjuge"
                                type="text"
                                label="Contato"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={8}>
                            <TextField
                                id="filhos"
                                type="text"
                                label="Filhos"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <TextField
                                id="faixaEtariaFilhos"
                                type="text"
                                label="Faixa etária filhos"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TextField
                                id="animaisEstimacao"
                                type="text"
                                label="Animais de estimação"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TextField
                                id="hobbies"
                                type="text"
                                label="Hobbies"
                                onChange={this.updateField}
                                state={this.state.fieldStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4} smOffset={4}>
                            <Button
                                id="saveClient"
                                onClick={this.saveClient}
                                bsStyle="primary"
                                block
                            >
                                Cadastrar
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
    render() {
        return (
            this.state.renderForm ? this.renderClientForm() : this.renderClientList()
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/Home.jsx